import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {SL5AnagrafService} from '../../../general-services/service-sl5-anagraf/sl5-anagraf.service';
import {L3Model} from '../../../../models/L3Model';
import * as toastr from 'toastr';
import {LoaderService} from '../../../general-services/service-loader/loader.service';

@Component({
  selector: 'app-new-l3-anagraf',
  templateUrl: './new-sl5-anagraf.component.html',
  styleUrls: ['./new-sl5-anagraf.component.scss']
})
export class NewSl5AnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  l3: L3Model;
  formValidator: FormGroup;
  formBuilder: FormBuilder;
  saveSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private sl5AnagrafService: SL5AnagrafService, private loaderService: LoaderService) {
    super();

    this.l3 = new L3Model();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [this.l3.cod, [Validators.required]],
      description: [this.l3.description, [Validators.required]]
    });
  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SL5_ANAGRF]);
  }

  save(event: any, form: NgForm, clickSalva ?: boolean) {
    if (event.key === 'Enter' || clickSalva) {
      event.preventDefault();
      this.l3.cod = this.formValidator.value.cod;
      this.l3.description = this.formValidator.value.description;
      this.saveSubscribe = this.sl5AnagrafService.save(this.sl5AnagrafService.baseUrl, this.l3).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, SL5 Cod already exists', 'Warning');
          } else {
            toastr.success('SL5 added with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SL5_ANAGRF]);
          }
        }, error => {
          this.loaderService.display(false);
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

  // convenience getter for easy access to form fields
  get fv() { return this.formValidator.controls; }

}

